<template>
  <NotificationBar type="pause" class="mb-4">
    <NotificationBarTitle>
      Order On{{holdTypeTitle}} Hold
    </NotificationBarTitle>
    <p class="font-weight-bold">The order was placed on{{holdTypeTitle}} hold with the following reason</p>
    <p class="well m-0">{{order.holdReason}}</p>
    <small>By {{holdUserName}} at {{order.holdDate | formatDateTime}}</small><br />
    <NotificationBarButton @click="unHoldOrder" icon="fa-play" v-if="userHasUpdatePermission(PermissionTypes.OrderPermissionTypes.order) && canUnHoldOrder">Resume Order</NotificationBarButton>
    &nbsp;&nbsp;
    <NotificationBarButton @click="cancelOrder" icon="fa-times" v-if="userHasUpdatePermission(PermissionTypes.OrderPermissionTypes.orderCancel) && canCancelOrder">Cancel Order</NotificationBarButton>
  </NotificationBar>
</template>

<script>
import { OrderHoldTypes, OrderHoldTypeLookup } from '@/store/types'

export default {
  name: 'OrderHoldBar',
  props: {
    order: Object,
    canUnHoldOrder: Boolean,
    canCancelOrder: Boolean
  },
  computed: {
    holdUserName() {
      if(!this.order)
        return ''
      if(this.order.holdUser)
        return this.order.holdUser.name
      return 'System'
    },
    holdTypeTitle() {
      if(!this.order.holdType)
        return ''

      return ' ' + this.formatLookupName(this.order.holdType, OrderHoldTypeLookup)
    }
  },
  methods: {
    unHoldOrder() {
      this.$emit('unHoldOrder')
    },
    cancelOrder() {
      this.$emit('cancelOrder')
    }
  }
}
</script>